<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_title_wrap">
        <h4>{{ $t("MSG_TXT_TASK_MNTR_TYPE_BSC_INFO") }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-10">
            <sui-module-submodule-select
              ref="moduleSubModuleSelect"
              :page-id="pageId"
              :selected-md="taskMonitoringTypeData.moduleCode"
              :selected-smd="taskMonitoringTypeData.subModuleCode"
              :defaultMdOption="'select'"
              :defaultSmdOption="'select'"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_MNTR_TYPE_NM')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model.trim="taskMonitoringTypeData.taskMonitoringTypeName"
              placeholder
              maxlength="100"
              :readonly="false"
            />
            <!-- <sui-text-field placeholder :disabled="true" :readonly="false">
            </sui-text-field> -->
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_EXPL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <textarea
              v-model.trim="taskMonitoringTypeData.taskMonitoringTypeContent"
              maxlength="1000"
            />
          </div>
        </div>
      </div>
      <div class="comm_title_wrap">
        <h4>{{ $t("MSG_TXT_TASK_MNTR_TYPE_DTL_INFO") }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_MNTR_PRD')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-10">
            <sui-code-select
              ref="cycleType"
              :selected="taskMonitoringTypeData.taskMonitoringCycleTypeCode"
              :codeId="'COD_TASK_MNTR_CYCL_TYPE'"
              :defaultOption="'select'"
            />
            <div
              v-show="taskMonitoringTypeData.taskMonitoringCycleTypeCode.key == 'W'"
              class="comp_spacing"
            />
            <sui-code-select
              v-show="taskMonitoringTypeData.taskMonitoringCycleTypeCode.key == 'W'"
              :selected="taskMonitoringTypeData.taskMonitoringStandardDayOfTheWeekCode"
              :codeId="'COD_TASK_MNTR_STNRD_DYWK'"
              :defaultOption="'select'"
            />

            <div
              v-show="taskMonitoringTypeData.taskMonitoringCycleTypeCode.key == 'M'"
              class="comp_spacing"
            />
            <sui-custom-select
              v-show="taskMonitoringTypeData.taskMonitoringCycleTypeCode.key == 'M'"
              :selected="taskMonitoringTypeData.taskMonitoringStandardDay"
              :option-list="taskMonitoringStandardDayOptionList"
            />

            <div class="comp_spacing" />
            <sui-time-picker
              ref="timePicker"
              v-model="timePickerValue"
              format="HH:mm"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_RSULT_SEND_MD')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-10">
            <sui-code-select
              :selected="taskMonitoringTypeData.taskMonitoringSendMediaCode"
              codeId="COD_TASK_MNTR_SEND_MD"
              :defaultOption="'select'"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_SEND_TMPLT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model.trim="taskMonitoringTypeData.taskMonitoringSendTemplateId"
              placeholder
              maxlength="25"
              :disabled="false"
              :readonly="false"
            />
            <div class="comp_spacing" />
            <sui-button
              type="button"
              name="button"
              class="btn_innerTbl_border"
              @click="onPopSendTemplate"
            >
              {{ $t("MSG_BTN_SEARCH") }}
            </sui-button>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_EXTC_STNRD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <sui-text-field
              v-model.trim="taskMonitoringTypeData.taskMonitoringExtractionStandardValue"
              placeholder
              maxlength="112"
              :readonly="false"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-2">
            <sui-input-label
              :label="$t('MSG_TXT_EXTC_FTXT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-10">
            <textarea
              v-model.trim="taskMonitoringTypeData.taskMonitroingExtractionFullTextValue"
              maxlength="1000"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-2">
          <sui-input-label
            :label="$t('MSG_TXT_USE_YN')"
            :vertical="false"
          />
        </div>
        <div class="col-xs-10">
          <sui-radio
            v-model="taskMonitoringTypeData.taskMonitoringTypeUseYn"
            value="Y"
          >
            Yes
          </sui-radio>
          <sui-radio
            v-model="taskMonitoringTypeData.taskMonitoringTypeUseYn"
            value="N"
          >
            No
          </sui-radio>
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClose"
      >
        {{ $t("MSG_BTN_CANCEL") }}
      </sui-button>
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        @click="onSave"
      >
        {{ $t("MSG_BTN_SAVE") }}
      </sui-button>
    </div>
  </div>
</template>
<script>

export default {
  name: 'PGE_CMS_00013_P01', // eslint-disable-line vue/name-property-casing
  props: {
    pageId: {
      type: String,
      default: 'PGE_CMS_00013',
    },
    taskMonitoringTypeUID: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      isModification: false,
      taskMonitoringStandardDayOptionList: [],

      timePickerValue: {
        HH: '00',
        mm: '00',
      },

      taskMonitoringTypeData: {
        taskMonitoringTypeUID: '',
        moduleCode: { key: '', label: '' },
        subModuleCode: { key: '', label: '' },
        taskMonitoringTypeName: '',
        taskMonitoringCycleTypeCode: { key: '', label: '' },
        taskMonitoringStandardDayOfTheWeekCode: { key: '', label: '' },
        taskMonitoringStandardDay: { key: '', label: '' },
        taskMonitoringStandardTime: '',
        taskMonitoringSendMediaCode: { key: '', label: '' },
        taskMonitoringSendTemplateId: '',
        taskMonitoringExtractionStandardValue: '',
        taskMonitroingExtractionFullTextValue: '',
        taskMonitoringTypeContent: '',
        taskMonitoringTypeUseYn: 'Y',

        firstRegistrationUserId: '',
        firstRegistrationDTM: '',
        finalModificationUserId: '',
        finalModificationDTM: '',
        originalFinalModificationDTM: '',
      },


    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능

  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  mounted() {
    if (utils.isEmpty(this.taskMonitoringTypeUID) === false) {
      this.isModification = true;
      this.searchTaskMonitoringType(this.taskMonitoringTypeUID);
    }

    for (let i = 1; i <= 31; i += 1) {
      this.taskMonitoringStandardDayOptionList.push({ key: `${i}`, label: `${i}` });
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /** ***************************************************************************
        이벤트 영역
        ***************************************************************************** */
    onSave() {
      this.save();
    },
    onClose() {
      this.$emit('close');
    },
    onPopSendTemplate() {
      utils.openLayerPopup('PGE_CMZ_00042', this.onPagePopupCloseSendTemplate, {
        pageInitialData: {},
        size: 'lg',
      });
    },
    onPagePopupCloseSendTemplate(objSendTemplate) {
      if (objSendTemplate) {
        this.taskMonitoringTypeData.taskMonitoringSendTemplateId = objSendTemplate.sendTemplateId;
      }
    },
    /** ***************************************************************************
        함수 영역
        ***************************************************************************** */
    searchTaskMonitoringType(sTaskMonitoringTypeUID) {
      http.request(this.pageId, 'DTS_CMS_00033', {
        path: {
          'task-monitoring-type-id': utils.trim(sTaskMonitoringTypeUID),
        },
      }).then(res => {
        // util.printDatasetFieldsFromObject(res.data); // data 기준으로 datafiels를 출력해주는 함수

        const has = Object.prototype.hasOwnProperty;
        utils.forEach(res.data, (value, key) => {
          if (key !== 'moduleCode' && key !== 'subModuleCode') {
            if (utils.has(this.taskMonitoringTypeData, key)) {
              if (has.call(this.taskMonitoringTypeData[key], 'key')) {
                utils.set(this.taskMonitoringTypeData, key, { key: utils.trim(value), label: '' });
              } else {
                utils.set(this.taskMonitoringTypeData, key, value);
              }
            }
          }
        });

        this.$refs.moduleSubModuleSelect.selectMdSmd(res.data.moduleCode, res.data.subModuleCode);

        const sStandarDate = `${this.taskMonitoringTypeData.taskMonitoringStandardTime}`;
        this.timePickerValue = { HH: sStandarDate.substr(0, 2), mm: sStandarDate.substr(2, 2) };

        this.taskMonitoringTypeData.originalFinalModificationDTM = this.taskMonitoringTypeData.finalModificationDTM;
      }).catch(error => {
        console.log(error);
      });
    },
    save() {
      // form validation
      if (!this.formValidate(this.taskMonitoringTypeData)) {
        return false;
      }

      this.taskMonitoringTypeData.taskMonitoringStandardTime = `${this.timePickerValue.HH}${this.timePickerValue.mm}`;

      // formData -> paramsObj변환 { key : value, key : value }
      const dataParams = utils.reduce(this.taskMonitoringTypeData, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});

      let sDataService = 'DTS_CMS_00034';

      if (this.isModification) {
        sDataService = 'DTS_CMS_00035';
      }

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, sDataService, {
          path: {
            'task-monitoring-type-id': utils.trim(this.taskMonitoringTypeData.taskMonitoringTypeUID),
          },
          data: dataParams,
        }).then(res => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.$emit('save');
          console.log(res.data);
        }).catch(error => {
          console.log(error);
        });
      });

      return true;
    },
    formValidate(formData) {
      if (utils.isEmpty(utils.trim(formData.moduleCode.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_MDLE')));
        return false;
      }
      if (utils.isEmpty(utils.trim(formData.subModuleCode.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_SMDLE')));
        return false;
      }
      if (utils.isEmpty(utils.trim(formData.taskMonitoringTypeName))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_TASK_MNTR_TYPE_NM')));
        return false;
      }

      if (utils.isEmpty(utils.trim(formData.taskMonitoringCycleTypeCode.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_TASK_MNTR_PRD')));
        return false;
      }

      if (utils.trim(formData.taskMonitoringCycleTypeCode.key) === 'W'
        && utils.isEmpty(utils.trim(formData.taskMonitoringStandardDayOfTheWeekCode.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_TASK_MNTR_PRD')));
        return false;
      }

      if (utils.trim(formData.taskMonitoringCycleTypeCode.key) === 'M'
       && utils.isEmpty(utils.trim(formData.taskMonitoringStandardDay.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_TASK_MNTR_PRD')));
        return false;
      }

      if (utils.isEmpty(utils.trim(formData.taskMonitoringSendMediaCode.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_RSULT_SEND_MD')));
        return false;
      }

      if (this.$refs.timePicker.isValid() === false) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_CONFIRM'), this.$t('MSG_TXT_TIME')));
        return false;
      }
      return true;
    },
  },
};
</script>
<style scoped>
</style>
